import { render } from "./third-register-next.vue?vue&type=template&id=0dbac2a9"
import script from "./third-register-next.vue?vue&type=script&lang=js"
export * from "./third-register-next.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/sign-log/broker/third-register-next.vue'],['render',render],['__file',"third-register-next.vue"]])

export default __exports__